export default function arrayFromNumber(
  count: number,
  callback: (_, index: number) => void
) {
  return Array.from(Array(count).keys()).map(callback);
}
